// EditReminderScreen.tsx
import React from 'react';
import {View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {RouteProp, useNavigation, useRoute} from '@react-navigation/native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import sharedTestIDs from '/constant/TestIDs/Shared';
import testProperties from '/util/testing/testProperties';

import {ReminderForm} from '../ReminderForm';
import {ReminderData} from '../ReminderUtils/ReminderUtils.util';

import styles from './EditCheckInReminder.style';

// Define the callback type
type ReminderDataCallback = (data: ReminderData | null) => void;
// Define the navigation params type for the stack
type RootStackParamList = {
  EditReminderScreen: {
    onDataReceived: ReminderDataCallback;
    initialData: ReminderData;
  };
};
const EditCheckInReminder = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'EditReminderScreen'>>();
  const navigation = useNavigation();
  const {onDataReceived, initialData, candidateId} = route.params;

  const handleDataReceived = (data: ReminderData) => {
    onDataReceived(data);
    navigation.goBack();
  };

  const onDelete = () => {
    onDataReceived(null);
    navigation.goBack();
  };

  return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <View style={styles.header}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            accessibilityRole="button"
            accessibilityLabel="Go back">
            <Icon name="chevron-left" style={styles.backButton} />
          </TouchableOpacity>
          <Text
            variant="heading"
            style={styles.headerTitle}
            {...testProperties(sharedTestIDs.sharedScreenTitle)}>
            Check-in reminder
          </Text>
        </View>
        <ReminderForm
          isEdit={true}
          initialData={initialData}
          onDataReceived={handleDataReceived}
          onDelete={onDelete}
          candidateId={candidateId}
        />
      </View>
    </SafeAreaView>
  );
};

export default EditCheckInReminder;
